class VocalsAudioContext {
  constructor() {
    this.audioContext = null;

    this.songGainNode = null;

    this.songVolume = 1;

    this.buffers = new Map();

    this.sources = new Map();

    this.gainNodes = new Map();

    document.addEventListener("click", () => this.resume());
    document.addEventListener("keydown", () => this.resume());
  }

  getAudioContext() {
    if (!this.audioContext) {
      this.audioContext = new (
        window.AudioContext || window.webkitAudioContext
      )();

      this.songGainNode = this.audioContext.createGain();

      this.songGainNode.connect(this.audioContext.destination);
    }

    return this.audioContext;
  }

  async resume() {
    if (this.audioContext && this.audioContext.state === "suspended") {
      await this.audioContext.resume();
    }
  }

  setSongVolume(volume) {
    this.songVolume = volume;

    if (this.songGainNode) {
      this.songGainNode.gain.setValueAtTime(
        volume,
        this.getAudioContext().currentTime,
      );
    }
  }

  async preload(vocalId, url) {
    if (this.buffers.has(vocalId)) return this.buffers.get(vocalId);

    const response = await fetch(url);

    const buffer = await response.arrayBuffer();

    const audio = await this.getAudioContext().decodeAudioData(buffer);

    this.buffers.set(vocalId, audio);

    return audio;
  }

  async play(vocalId, url, volume = 1, offset = 0) {
    await this.resume();

    this.stop(vocalId);

    let buffer = this.buffers.get(vocalId);

    if (!buffer) buffer = await this.preload(vocalId, url);

    const source = this.audioContext.createBufferSource();

    source.buffer = buffer;

    const gain = this.audioContext.createGain();

    gain.gain.value = volume;

    source.connect(gain);

    gain.connect(this.songGainNode);

    source.start(0, offset);

    this.sources.set(vocalId, source);

    this.gainNodes.set(vocalId, gain);

    source.onended = () => {
      this.sources.delete(vocalId);
      this.gainNodes.delete(vocalId);
    };
  }

  pause(vocalId) {
    this.stop(vocalId);
  }

  stop(vocalId) {
    const source = this.sources.get(vocalId);

    if (!source) return;

    try {
      source.stop();
    } catch {}

    this.sources.delete(vocalId);
    this.gainNodes.delete(vocalId);
  }

  stopAll() {
    [...this.sources.keys()].forEach((id) => this.stop(id));
  }

  setVolume(vocalId, volume) {
    const gain = this.gainNodes.get(vocalId);

    if (!gain) return;

    gain.gain.linearRampToValueAtTime(
      volume,
      this.audioContext.currentTime + 0.05,
    );
  }
}

export default new VocalsAudioContext();
